import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Colors from '../../../../ui/global/Colors';
import Fonts from '../../../../ui/global/Fonts';
import Icon from '../../../../ui/global/Icon';

// Global styles for mention pills created via DOM manipulation
export const MentionPillStyles = createGlobalStyle`
  .mention-pill {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: ${Colors.grey8};
    border-radius: 40px;
    border: 1px solid ${Colors.transparent};
    padding: 1px 8px 1px 6px;
    margin: -2px 0;
    gap: 2px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
    
    &:hover {
      border: 1px solid ${Colors.grey6};
    }

    &.mention-highlight {
      background-color: #577BA2;
      border-radius: 0;
      color: ${Colors.white};
    }
  }
  
  .mention-type {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-family: ${Fonts.lexendMedium.fontFamily};
    font-weight: ${Fonts.lexendMedium.fontWeight};
    color: ${Colors.grey4};
    margin: auto;
    pointer-events: none;
  }
  
  .mention-text {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-family: ${Fonts.lexendMedium.fontFamily};
    font-weight: ${Fonts.lexendMedium.fontWeight};
    color: ${Colors.white};
    overflow: hidden;
    text-overflow: ellipsis;
    margin: auto;
    pointer-events: none;
  }
`;

export interface Mention {
  id: string;
  type: string;
  name: string; // This will be used for display (the name)
}

// Helper functions for DOM manipulation
export const createMentionPillElement = (mention: Mention, onMentionClicked?: (mention: Mention) => void): HTMLElement => {
  // Create a mention pill element with the MentionPill styling
  const pillElement = document.createElement('span');
  pillElement.className = 'mention-pill';
  pillElement.contentEditable = 'false';
  pillElement.setAttribute('data-type', mention.type);
  pillElement.setAttribute('data-id', mention.id);
  pillElement.setAttribute('data-name', mention.name);
  
  // Create type span
  const typeSpan = document.createElement('span');
  typeSpan.className = 'mention-type';
  typeSpan.textContent = `@${mention.type}:`;
  
  // Create text span
  const textSpan = document.createElement('span');
  textSpan.className = 'mention-text';
  textSpan.textContent = mention.name;
  
  // Append the spans to the pill
  pillElement.appendChild(typeSpan);
  pillElement.appendChild(textSpan);
  
  // Add click handler if provided
  if (onMentionClicked) {
    pillElement.addEventListener('click', (e) => {
      e.stopPropagation();
      onMentionClicked({
        id: mention.id,
        type: mention.type,
        name: mention.name,
      });
    });
  }
  
  return pillElement;
};

// const PillContainer = styled.span`
//   display: inline-flex;
//   align-items: center;
//   background-color: ${Colors.grey8};
//   border-radius: 12px;
//   border: 1px solid ${Colors.transparent};
//   height: 24px;
//   padding: 0 6px 0 8px;
//   margin: 0 2px;
//   gap: 5px;
//   cursor: pointer;
//   user-select: none;
//   white-space: nowrap;
//   vertical-align: middle;
//   max-width: 200px;
//   overflow: hidden;
  
//   &:hover {
//     border: 1px solid ${Colors.grey6};
//   }
// `;

// const MentionType = styled.span`
//   font-family: ${Fonts.lexendMedium.fontFamily};
//   font-weight: ${Fonts.lexendMedium.fontWeight};
//   color: ${Colors.grey4};
//   text-align: center;
//   vertical-align: middle;
//   margin: auto;
//   pointer-events: none;
// `;

// const MentionText = styled.span`
//   font-family: ${Fonts.lexendMedium.fontFamily};
//   font-weight: ${Fonts.lexendMedium.fontWeight};
//   color: ${Colors.white};
//   text-align: center;
//   vertical-align: middle;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   margin: auto;
//   pointer-events: none;
// `;

// interface MentionPillProps {
//   mention: Mention;
//   onClick?: (mention: Mention) => void;
// }

// const MentionPill: React.FC<MentionPillProps> = ({ mention, onClick }) => {
//   const handleClick = (e: React.MouseEvent) => {
//     e.stopPropagation();
//     if (onClick) {
//       onClick(mention);
//     }
//   };

//   return (
//     <PillContainer 
//       className="mention-pill" 
//       onClick={handleClick}
//       data-type={mention.type}
//       data-id={mention.id}
//       data-name={mention.name}
//       contentEditable="false"
//     >
//       <MentionType className="mention-type">{`@${mention.type}:`}</MentionType>
//       <MentionText className="mention-text">{mention.name}</MentionText>
//     </PillContainer>
//   );
// };

// export default MentionPill;
